import type from 'type-detect';

/**
 * 文档：https://github.com/chaijs/type-detect
 */
export default type;

/**
 * 6种基本类型，不包含包装器的值和其它特殊值。
 * - Boolean
 * - Null
 * - Undefined
 * - Number
 * - String
 * - Symbol
 * 1种Object，不包含`null`
 * - Object
 */
export function isBoolean(val) {
  return type(val) === 'boolean';
}

export function isNull(val) {
  return type(val) === 'null';
}

export function isUndefined(val) {
  return type(val) === 'undefined';
}

// 有效的数值，反例是：`NaN`, `Infinity`, `Number.NEGATIVE_INFINITY`
export function isNumber(val) {
  return type(val) === 'number' && (val - val === 0);
}

export function isString(val) {
  return type(val) === 'string';
}

export function isSymbol(val) {
  return type(val) === 'symbol';
}

// 排除`null`
export function isObject(val) {
  return typeof val === 'object' && !isNull(val);
}

/**
 * 其它常用的判断
 */
export function isArray(val) {
  return type(val) === 'Array';
}

export function isFunction(val) {
  return type(val) === 'function';
}

export function isRegExp(val) {
  return type(val) === 'RegExp';
}

export function isArguments(val) {
  return type(val) === 'Arguments';
}
